import { useShopConfig } from './shopConfig';

export const useListingFlowConfig = () => {
  const { listingFlowConfig } = useShopConfig();
  return listingFlowConfig;
};
